import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getMandateUrl } from "../utils/urlHelper";

const mandateApi = createApi({
  reducerPath: "mandate",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    createMandate: builder.mutation({
      query: (body) => ({
        url: getMandateUrl("create_mandate_record"),
        method: "POST",
        body,
      }),
    }),
    mandateStatus: builder.mutation({
      query: (body) => ({
        url: getMandateUrl("mandate_status"),
        method: "POST",
        body,
      }),
    }),
    mandateAvailability: builder.mutation({
      query: (body) => ({
        url: getMandateUrl("check_mandate_availability"),
        method: "POST",
        body,
      }),
    }),
    verifiyUpiId: builder.mutation({
      query: (body) => ({
        url: getMandateUrl("verify_upi"),
        method: "POST",
        body,
      }),
    }),
    checkUpiMandateStatus: builder.mutation({
      query: (body) => ({
        url: getMandateUrl("check_upi_mandate_status"),
        method: "POST",
        body,
      }),
    }),
    checkOpenMandateStatus: builder.mutation({
      query: (body) => ({
        url: getMandateUrl("check_open_mandate_status"),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useCreateMandateMutation,
  useMandateStatusMutation,
  useMandateAvailabilityMutation,
  useVerifiyUpiIdMutation,
  useCheckUpiMandateStatusMutation,
  useCheckOpenMandateStatusMutation,
} = mandateApi;

export { mandateApi };
